'use strict';

import type { GlobConnectureOrg } from '../../Entities/Glob/GlobConnectureOrg';
import { EntityCollection } from '../EntityCollection';

export class GlobConnectureOrgCollection extends EntityCollection<GlobConnectureOrg> {}
